import { FC, ReactNode } from "react";
import QuickFilters, { IQuickFilters } from "./QuickFilters";
import React from "react";
import DividerVertical from "../divider/DividerVertical";

export interface IQuickFilterGroup {
  filters?: IQuickFilters,
  title?: ReactNode,
}

const QuickFilterGroups: FC<{
  groups: IQuickFilterGroup[],  
  preDivider?: boolean,
}> = ({
  groups,
  preDivider,
}) => !groups?.length
  ? null
  : (
    <div className="flex gap-4">
      {!!preDivider && <DividerVertical />}
      {groups.map(({ filters, title }, i) => (
        <React.Fragment key={`filterGroup${i}${title || ''}`}>
          <div className="flex gap-2 items-center">
            {!!title && <div className="text-sm">{title}:</div>}            
            <QuickFilters {...filters} />
          </div>
          {!!(groups?.length !== i + 1) && <DividerVertical />}          
        </React.Fragment>
      ))}      
    </div>
  );

export default QuickFilterGroups;
